/* import __COLOCATED_TEMPLATE__ from './team-selection-dropdown.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class TeamPageTeamSelectionDropdown extends Component {
  @service router;

  @action
  async handleTeamLinkClick(team, dropdownActions) {
    dropdownActions.close();
    this.router.transitionTo('team', team.id);
  }
}
